import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../sidebar/index.js';
import PageViewFooter from '../footer/index.js';
import Header from '../header/index.jsx';
import './index.css';
const AppLayout = () => {
	useEffect(() => {
		document.body.classList.add('ant-layout-has-sider');
	}, []);

	return (
		<div className="main-layout">
			<Header />
			<Sidebar />
			<div className="main-layout-content">
				<Outlet />
			</div>
			<PageViewFooter />
		</div>
	);
};

export default AppLayout;
